import React, { useEffect } from "react";

import { Route, Routes } from "react-router-dom";

import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";

import Toasts from "@readai/common/containers/Toasts";
import useAuth, { AuthProvider } from "@readai/common/hooks/useAuth";
import theme from "@readai/common/theme";

import useEnsureUser from "@app/booking/hooks/useEnsureUser";
import { AppContainer } from "@app/booking/layouts/styles";

import AdapterLuxonCustom from "./AdapterLuxonCustom";
import ErrorPage from "./ErrorPage";
import EventDetails from "./EventDetails";
import ScheduleEvent from "./ScheduleEvent";
import SplashPage from "./SplashPage";
import initializeSentry from "./tracking/sentry";

const BookingRoutes = () => {
  // Necessary to sync login state between the main app and the booking app
  useEnsureUser();

  const { thirdPartyDataCollectionEnabled } = useAuth();

  // This effect will re-initialize Sentry if third party data collection
  // changes from disabled to enabled (such as after a user logs out)
  useEffect(() => {
    if (thirdPartyDataCollectionEnabled) {
      initializeSentry();
    }
  }, [thirdPartyDataCollectionEnabled]);

  return (
    <Routes>
      <Route index element={<SplashPage />} />
      <Route path="/:ownerVanityId/:linkId?" element={<ScheduleEvent />} />
      <Route path="/events/*" element={<EventDetails />} />
      <Route path="404" element={<ErrorPage code={404} />} />
      <Route path="500" element={<ErrorPage code={500} />} />
    </Routes>
  );
};

/** Main content of the Booking app */
const Booking = () => (
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterLuxonCustom}>
      <CssBaseline />
      <AuthProvider>
        <AppContainer>
          <Toasts />
          <BookingRoutes />
        </AppContainer>
      </AuthProvider>
    </LocalizationProvider>
  </ThemeProvider>
);

export default Booking;
